import React, { useState, useEffect } from 'react';
import './PageHeader.scss';
import buyMeCoffee from '../../images/bmc.png';
import FeedbackModal from '../../Components/FeedbackModal/FeedbackModal.jsx';
import AboutMeModal from '../../Components/AboutMeModal/AboutMeModal.jsx';
import cn from 'classnames';
import { Icon } from 'semantic-ui-react';
import CityCheckbox from '../../Components/CityCheckbox/CityCheckbox.jsx';
import { useLocation, useNavigate } from 'react-router-dom';

const PageHeader = ({
  cities,
  setCities,
  allLoaded,
  noCityWarning,
  setNoCityWarning,
}) => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const bookFromUrl = params.get('book');
  const [isFeedbackModalOpen, setIsFeedbackModalOpen] = useState(false);
  const [isAboutMeModalOpen, setIsAboutMeModalOpen] = useState(false);
  const [searchValue, setSearchValue] = useState('');
  const [tooLongWarning, setTooLongWarning] = useState(false);
  const isAtResultPage = location.pathname.includes('result');
  const navigation = useNavigate();
  const isResultPage = location.pathname !== '/';

  useEffect(() => {
    const atLeastOneCitySelected = Object.values(cities).some(
      (selected) => selected
    );

    if (!atLeastOneCitySelected && !noCityWarning) {
      setNoCityWarning(true);
    } else if (atLeastOneCitySelected && noCityWarning) {
      setNoCityWarning(false);
    }
  }, [cities, noCityWarning]);

  useEffect(() => {
    if (bookFromUrl && !searchValue) {
      setSearchValue(bookFromUrl);
    }
  }, [bookFromUrl]);

  useEffect(() => {
    const specialCharacters = /[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;

    if (searchValue.length > 10 || specialCharacters.test(searchValue)) {
      setTooLongWarning(true);
    } else if (tooLongWarning) {
      setTooLongWarning(false);
    }
  }, [searchValue, tooLongWarning]);

  const handleChange = (e) => {
    const { value } = e.target;

    if (e.target instanceof HTMLInputElement) {
      if (e.key === 'Enter') {
        if (searchValue) {
          return navigation(`/result?book=${searchValue}`);
        }
      }
    }

    setSearchValue(value);
  };

  return (
    <>
      <div className="page-header">
        <div className="page-header__item">
          小額捐款
          <br />
          <a
            href="https://www.buymeacoffee.com/twlibraryebook/membership"
            target="_blank"
          >
            <img
              src={buyMeCoffee}
              height="28"
              width="auto"
              alt="buymecoffee"
              style={{ marginTop: '0.1rem' }}
            />
          </a>
        </div>
        <div className="page-header__item">
          關於本站
          <br />
          <img
            src="https://img.icons8.com/pastel-glyph/64/000000/info--v1.png"
            style={{ height: '29px ', cursor: 'pointer' }}
            onClick={() => setIsAboutMeModalOpen(true)}
          />
        </div>
        <div className="page-header__item">
          有話想說 <br />
          <img
            src="https://img.icons8.com/ios/50/000000/speech-bubble-with-dots.png"
            style={{ height: '30px ', cursor: 'pointer' }}
            onClick={() => setIsFeedbackModalOpen(true)}
          />
        </div>
        <FeedbackModal
          open={isFeedbackModalOpen}
          closeModal={() => setIsFeedbackModalOpen(false)}
        />

        <AboutMeModal
          open={isAboutMeModalOpen}
          closeModal={() => setIsAboutMeModalOpen(false)}
        />
      </div>
      <>
        <h2>
          <a href="https://taiwanlibrarysearch.herokuapp.com/">
            台灣圖書館電子書搜尋
          </a>
        </h2>
        {!isAtResultPage ? (
          <h3 style={{ margin: '0 auto' }}>一鍵搜尋全台公立圖書館</h3>
        ) : null}
      </>
      <div
        style={{
          position: 'relative',
          display: 'flex',
          justifyContent: 'center',
          margin: isAtResultPage ? '25px auto 0' : '10px auto 0',
        }}
      >
        <div>
          <input
            className="book-search-input"
            placeholder="書籍關鍵字/作者/ISBN ..."
            name="institution"
            onChange={handleChange}
            onKeyDown={handleChange}
            value={searchValue}
            disabled={isResultPage && !allLoaded}
          />
          <button
            className={cn('book-search-submit', {
              'book-search-submit--disabled':
                !searchValue || noCityWarning || (isResultPage && !allLoaded),
            })}
            disabled={
              !searchValue || noCityWarning || (isResultPage && !allLoaded)
            }
            onClick={() => navigation(`/result?book=${searchValue}`)}
          >
            <i className="search icon"></i>
            搜尋
          </button>
        </div>
      </div>
      {tooLongWarning ? (
        <div className="too-long-warning">
          <Icon name="exclamation" />
          <div className="content">
            若輸入之關鍵字<b>過長</b>或包含<b>特殊字元</b>
            ，容易造成搜尋錯誤，建議擷取書名開頭搜尋以及避開<b>特殊字元</b>。
          </div>
        </div>
      ) : null}
      <CityCheckbox setCities={setCities} cities={cities} />
      {noCityWarning ? (
        <div className="no-city-warning">
          <Icon name="exclamation" />
          <div className="content">請至少選擇一個圖書館</div>
        </div>
      ) : null}
    </>
  );
};

export default PageHeader;
